import { Board } from "@sportactics/board-editing";
import { createContext } from "react";

import { LazyValue, useLazyContext } from "~utils";

import { Preferences } from "../preferences";

export function useBoardImage(): useBoardImageReturn {
  return useLazyContext(BoardImageContext);
}

export type useBoardImageReturn = {
  generateBoardImage: (board: Board, preferences: Preferences) => Promise<File>;
};

export const BoardImageContext =
  createContext<LazyValue<useBoardImageReturn>>(undefined);
